import { Routes } from '@angular/router';
import { NationalHolidayDetailComponent } from './national-holiday-detail.component';
import { NationalHolidayDetailResolver } from './resolvers/national-holiday-detail.resolver';

export const nationalHolidayDetailRoutes: Routes = [
  {
    path: '',
    component: NationalHolidayDetailComponent,
    resolve: { pageData: NationalHolidayDetailResolver },
  },
];
